import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchFirstTenActiveCertifications(agro_exporter_id) {
    return RequesterV1.get(
      `dashboard/agro_exporter/certifications/${agro_exporter_id}/fetch_first_ten_active_certifications`
    );
  },
}
